import clsx from "classnames";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Container } from "reactstrap";
import styles from "./styles.module.scss";
import Bagicon from "/public/site-assets/svg/bag.svg";
import ClipIcon from "/public/site-assets/svg/clip.svg";
import FooterWave2Icon from "/public/site-assets/svg/footer-wave-2.svg";
import LeafIcon from "/public/site-assets/svg/leaf.svg";
import PotIcon from "/public/site-assets/svg/pot.svg";
import RulerIcon from "/public/site-assets/svg/ruler.svg";

export const AccordionFAQ = ({
  className,
  post,
  heading,
  content,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const [open, setOpen] = useState("0");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Adjust threshold as needed, make it smaller for more sensitive detection
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(sectionRef.current);

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
      // setIsVisible(!mobileDevice); // Hide motion on mobile devices
    };

    handleResize(); // Call initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <section ref={sectionRef} className={clsx(className, styles.root)}>
        {showTopWave && (
          <div
            className={clsx(
              "footer",
              topWaveDirection === "down" && "rotate",
              topWaveColor,
              topWaveBackground,
            )}
            style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
          >
            <FooterWave2Icon />
          </div>
        )}
        <Container className="position-relative">
          <div className="floating-icon">
            <PotIcon />
          </div>
          <div className="floating-icon">
            <RulerIcon />
          </div>
          <div className="floating-icon">
            <LeafIcon />
          </div>
          <div className="floating-icon">
            <ClipIcon />
          </div>
          <div className="floating-icon">
            <Bagicon />
          </div>
          {content && <h4 className={`mb-3 subtitle`}>{content}</h4>}
          {heading && <h3 className={`h3 mb-4`}>{heading}</h3>}
          <div>
            <Accordion open={open} toggle={toggle}>
              {post?.map((post, index) => (
                <motion.div
                  className={`w-100`}
                  initial={{ opacity: 0, y: 50 }}
                  animate={isVisible ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <AccordionItem className="w-100">
                    <AccordionHeader targetId={`${index}`} tag={`div`}>
                      {post.title}
                    </AccordionHeader>
                    <AccordionBody accordionId={`${index}`}>
                      <div dangerouslySetInnerHTML={{ __html: post.content }} />
                    </AccordionBody>
                  </AccordionItem>
                </motion.div>
              ))}
            </Accordion>
          </div>
        </Container>
        {showWave && (
          <div
            className={clsx(
              "footer",
              waveDirection === "down" && "rotate",
              waveColor,
              waveBackground,
            )}
            style={{ marginTop: "-1px" }}
          >
            <FooterWave2Icon />
          </div>
        )}
      </section>
    </>
  );
};

export default AccordionFAQ;
